'use client'

import type { ComponentProps, ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'
import {
	Breadcrumb,
	BreadcrumbEllipsis,
	BreadcrumbItem,
	BreadcrumbLink as BaseBreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@cocoonspace/ui/components/breadcrumb'
import { cn } from '@cocoonspace/ui/lib/utils'
import { HomeIcon } from 'lucide-react'

import { LocalizedLink } from '~/components/localized-link'

type BreadcrumbLinkProps = Omit<
	ComponentPropsWithoutRef<typeof BaseBreadcrumbLink>,
	'asChild'
>

const BreadcrumbLink = forwardRef<HTMLAnchorElement, BreadcrumbLinkProps>(
	({ children, href, ...props }, ref) => (
		<BaseBreadcrumbLink
			{...props}
			asChild
			href={href}
		>
			<LocalizedLink
				href={href}
				ref={ref}
			>
				{children}
			</LocalizedLink>
		</BaseBreadcrumbLink>
	),
)

BreadcrumbLink.displayName = 'BreadcrumbLink'

const HomeBreadcrumbItem = ({
	className,
	...props
}: Omit<ComponentProps<typeof BreadcrumbLink>, 'href'>) => (
	<BreadcrumbItem>
		<BreadcrumbLink
			{...props}
			className={cn('w-[32px] px-0', className)}
			href='/dashboard'
		>
			<HomeIcon size={14} />
		</BreadcrumbLink>
	</BreadcrumbItem>
)

HomeBreadcrumbItem.displayName = 'HomeBreadcrumbItem'

export {
	Breadcrumb,
	BreadcrumbEllipsis,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
}
